module.exports = __webpack_public_path__ + "static/ViewPort_hires-57877fdda9a5dce5debe5fa3d1e4ed29.jpg";